// Inserts a transformation into a cloudinary url
module.exports.withTransformation = (url, transformation) => {
  if (url) {
    let splitStr = url.split('upload/')
    if (transformation) return splitStr.join(`upload/${transformation}/`)
    else return url
  }
}

module.exports.getAlgoliaIndex = () => {
  if (process.env.OXYGEN === 'local' || process.env.GATSBY_ALGOLIA_INDEX === 'local') return 'local_typenexmedical'
  if (process.env.GATSBY_ALGOLIA_INDEX === 'production') return 'prod_and_test_typenexmedical'
  else return 'dev_typenexmedical'
}

module.exports.hexColors = {
  "#WHITE": "#FFFFFF",
  "#YELLOW": "#F9DF8D",
  "#GREEN": "#A6E5D8",
  "#PINK": "#F8CDD6",
  "#BLUE": "#99CAEA",
  "#TAN": "#DEBFA4",
  "#PURPLE": "#D5BAD8",
  "#PEACH": "#FD9FC8",
  "#ORANGE": "#FFBE9E",
  "#AQUA": "#25CAD3",
  "#GRAY": "#D0D2D3"
}